module.exports = __webpack_public_path__ + "img/new_phone.71fec5f2.svg";